import { css } from '@emotion/react'
import type React from 'react'

const S = {
  basic: css`
    display: inline-block;
  `,
  type: {
    vertical: (
      size: React.CSSProperties['height'],
      margin: React.CSSProperties['margin'],
      borderWidth: number,
      color: React.CSSProperties['borderColor'],
    ) => ({
      height: `${typeof size === 'number' ? size + 'px' : size}`,
      borderRight: `${borderWidth}px solid ${color}`,
      margin: `0 ${margin}px`,
    }),
    horizontal: (
      size: React.CSSProperties['width'],
      margin: React.CSSProperties['margin'],
      borderWidth: number,
      color: React.CSSProperties['borderColor'],
    ) => ({
      width: `${typeof size === 'number' ? size + 'px' : size}`,
      borderTop: `${borderWidth}px solid ${color}`,
      margin: `${margin}px 0`,
    }),
  },
}

export default S
